/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:52:59
 * @LastEditTime: 2023-03-02 17:48:00
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: /p2ps_vip_web/src/router/butterfly-flow-system/flow-direction-statistic-analy/modules/agentFlowDimensionRouter.js
 * 代理商流向维度
 */
const agentFlowDimensionRouter = [
  // 代理流向统计 meta_type 6-代理商 9-服务商
  {
    path: '/flowSystem/agency-flow-statistics/:meta_type',
    name: 'flowSystemAgencyFlowStatistics',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemAgencyFlowStatistics" */
      //   '../views/flowSystem/AgencyFlowStatistics.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemAgencyFlowStatistics" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/agent-flow-dimension/agent-flow-statis/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '服务商流向维度', //二级菜单
      6: {
        title: '代理流向统计',
      },
      9: {
        title: '服务商流向统计',
      },
    },
  },
  // 代理商关联流向
  {
    path: '/flowSystem/agency-relevance-statistics/:meta_type/:json',
    name: 'flowSystemAgencyRelevanceStatistics',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemAgencyFlowStatistics" */
      //   '../views/flowSystem/AgencyRelevanceStatistics.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemAgencyFlowStatistics" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/agent-flow-dimension/agent-ralate-flow/Page.vue'
      ),  //新迁移文件
    meta: {
      SecondaryMenu: '服务商流向维度', //二级菜单
      isMoreMeta: true,
      1: {
        title: '代理商关联流向',
      },
      2: {
        title: '代理商关联流向',
        breadcrumb: [
          {
            title: '代理流向统计',
            name: 'flowSystemAgencyFlowStatistics',
          },
        ],
      },
      3: {
        title: '服务商关联流向',
      },
      4: {
        title: '服务商关联流向',
        breadcrumb: [
          {
            title: '服务商流向维度',
            name: 'flowSystemAgencyFlowStatistics',
          },
        ],
      },
    },
  },
]
export default agentFlowDimensionRouter
